import { parse } from "date-fns";

import { ITag } from "store/entities/tags";

export default abstract class TagSerializer {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static deserialize(data: { [key: string]: any }, emptyCountFallback = true): ITag {
    let { count } = data;
    if (count === undefined && emptyCountFallback) {
      count = 0;
    }

    // @ts-expect-error TS(2322)
    const deserialized: ITag = {
      id: data.ID,
      name: data.name,
      teamId: data.teamID,
      ...(count !== undefined && { count }),
      createdAt: parse(data.createdAt),
      createdBy: data.createdBy,
      createdByType: data.createdByType,
      updatedAt: parse(data.updatedAt),
      updatedBy: data.updatedBy,
    };
    return deserialized;
  }

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static deserializeList(list: any): ITag[] {
    return list.map(TagSerializer.deserialize);
  }
}
